import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Button, FormControl, Table, Spinner, Modal, Dropdown } from "react-bootstrap";
import { useTable, usePagination, useGlobalFilter, useSortBy } from "react-table";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useDispatch } from "react-redux";
import { Fn_FillListData, Fn_GetReport } from "../../store/Functions";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const Report_DetailedWorker = () => {
    const [state, setState] = useState({
        id: 0,
        FillArray: [{Id:1,Name:'SHyam ji'},
            {Id:2,Name:'Rajesh ji'},
            {Id:3,Name:'Prem ji'},
        ],
      
        isProgress: true,
    });
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [DetailArr, setDetailArr] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    F_WorkerMaster:-1,
    toDate: new Date().toISOString().split('T')[0]    
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rtPage_Add = "/AddMCQH";
  const rtPage_Edit = "/EditMCQH";
  const breadCrumbTitle = "Points Data";
  const breadcrumbItem = "Points Data";
  const API_URL1 = "DetailedReport/0/token";
  const API_URL2 = "MixedStockReport/0/token";
  const API_URL = `${API_WEB_URLS.MASTER}/0/token/WorkerMaster`;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      Fn_FillListData(dispatch, setState, 'FillArray', API_URL + '/Id/'+obj.uid);
     

      setLoading(false);
    };

    fetchData();
  }, [dispatch, API_URL1]);

  const btnAddOnClick = () => {
    navigate(rtPage_Add, { state: { Id: 0 } });
  };

  const btnEditOnClick = (row) => {
    Fn_FillListData(dispatch, setDetailArr, "gridData", API_URL + "/Id/"+row.Id);
    setShowModal(true);
  };
  
  const data = useMemo(() => {
    return gridData;
  }, [gridData]);

  const columns = useMemo(
    () => [
      {
        Header: "WorkerName",
        accessor: "WorkerName",
      },
      {
        Header: "PointName",
        accessor: "PointName",
      },
    
      {
        Header: "Reading1",
        accessor: "Reading1",
      },
      {
        Header: "Reading2",
        accessor: "Reading2",
      },
      {
        Header: "NetReading",
        accessor: "NetReading",
      },
   
      {
        Header: "FuelRate",
        accessor: "FuelRate",
      },
      {
        Header: "OilSaleAmount",
        accessor: "OilSaleAmount",
      },
      {
        Header: "TotalSalesAmount",
        accessor: "TotalSalesAmount",
      },
      {
        Header: "CreditBalance",
        accessor: "CreditBalance",
      },
      {
        Header: "UPICollection",
        accessor: "UPICollection",
      },
      {
        Header: "LedgerCr",
        accessor: "LedgerCr",
      },
      {
        Header: "LedgerDr",
        accessor: "LedgerDr",
      },
      {
        Header: "Amount",
        accessor: "Amount",
      },
      {
        Header: "Remarks",
        accessor: "Remarks",
      },
      {
        Header: "SLedgerCr",
        accessor: "SLedgerCr",
      },
      {
        Header: "SLedgerDr",
        accessor: "SLedgerDr",
      },
      {
        Header: "SAmount",
        accessor: "SAmount",
      },
      {
        Header: "SRemarks",
        accessor: "SRemarks",
      },
      {
        Header: "Open Detail",
        Cell: ({ row }) => (
          <Button
            variant="success"
            size="sm"
            onClick={() => btnEditOnClick(row.original)}
          >
            Open
          </Button>
        ),
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    const obj = JSON.parse(localStorage.getItem("authUser"));

    let vformData = new FormData();
    
  
    vformData.append("Id", formData.F_WorkerMaster);
    vformData.append("ToDate", formData.toDate);

    Fn_GetReport(dispatch, setGridData, "tenderData", API_URL1, { arguList: { id:0, formData: vformData } }, true);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title={breadCrumbTitle} breadcrumbItem={breadcrumbItem} />

        <form onSubmit={handleSubmit}>
          <Row className="mb-3 align-items-center">
            <Col md="3">
              <Dropdown>
                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                  {state.FillArray.find(item => item.Id === formData.F_WorkerMaster)?.Name || "Select Worker"}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {state.FillArray.map(worker => (
                    <Dropdown.Item
                      key={worker.Id}
                      onClick={() => setFormData(prev => ({ ...prev, F_WorkerMaster: worker.Id }))}
                    >
                      {worker.Name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col md="3">
              <FormControl
                type="date"
                value={formData.toDate}
                onChange={(e) => setFormData(prev => ({ ...prev, toDate: e.target.value }))}
              />
            </Col>
            <Col md="3">
              <FormControl
                type="text"
                placeholder="Search"
                value={globalFilter || ""}
                onChange={(e) => setGlobalFilter(e.target.value)}
              />
            </Col>
            <Col md="2">
              <Button type="submit" variant="primary">
                Submit
              </Button>
            </Col>
          </Row>
        </form>

        <Table {...getTableProps()} responsive bordered striped>
          <thead>
            {headerGroups.map((headerGroup, headerGroupIndex) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={headerGroupIndex}>
                {headerGroup.headers.map((column, columnIndex) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={columnIndex}
                  >
                    {column.render("Header")}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, rowIndex) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={rowIndex}>
                  {row.cells.map((cell, cellIndex) => (
                    <td {...cell.getCellProps()} key={cellIndex}>
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </Table>

        <Row className="mt-2">
          <Col>
            <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
              {"<<"}
            </Button>{" "}
            <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
              {"<"}
            </Button>{" "}
            <Button onClick={() => nextPage()} disabled={!canNextPage}>
              {">"}
            </Button>{" "}
            <Button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
              {">>"}
            </Button>{" "}
            <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>{" "}
            </span>
            <span>
              | Go to page:{" "}
              <input
                type="number"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                  const page = e.target.value ? Number(e.target.value) - 1 : 0;
                  gotoPage(page);
                }}
                style={{ width: "50px" }}
              />
            </span>
            <select
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
              style={{ marginLeft: "10px" }}
            >
              {[5, 10, 20, 30, 40].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </Col>
        </Row>
      </Container>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
  <Modal.Header closeButton>
    <Modal.Title>Detailed Data</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {DetailArr ? (
      <Table responsive bordered striped>
        <thead>
          <tr>
            
            <th>LedgerNameCr</th>
            <th>LedgerNameDr</th>
            <th>Amount</th>
        
          </tr>
        </thead>
        <tbody>
          {DetailArr.map((item, index) => (
            <tr key={index}>
            
             
              <td>{item.LedgerNameCr}</td>
              <td>{item.LedgerNameDr}</td>
              <td>{item.Amount}</td>
     
            </tr>
          ))}
        </tbody>
      </Table>
    ) : (
      <div className="text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

    </div>
  );
};

export default Report_DetailedWorker;
